import React, {FC} from 'react'
import {useFormContext, Controller} from 'react-hook-form'
type InputProps = {
  name: string
  textPlaceholder?: string
  disabled?: boolean
  maxLength?: number
  Uppercase?: boolean
}

const InputTextArea: FC<InputProps> = ({
  name,
  textPlaceholder,
  maxLength = 1000,
  disabled = false,
  Uppercase = false,
  ...props
}) => {
  const {
    control,
    formState: {errors},
  } = useFormContext()
  const handleChange = (
    e: React.ChangeEvent<HTMLTextAreaElement>,
    field: {onChange: (value: string) => void},
  ) => {
    let value = e.target.value
    if (Uppercase) {
      value = value.toUpperCase()
    }

    field.onChange(value)
  }
  return (
    <div className='sdx_form_input'>
      <Controller
        name={name}
        control={control}
        render={({field}) => (
          <textarea
            {...field}
            className='form-control sdx-centra-input-form'
            placeholder={textPlaceholder}
            maxLength={maxLength}
            disabled={disabled}
            onChange={(e) => handleChange(e, field)}
          />
        )}
      />
      {errors[name] && <p>{errors[name]?.message?.toString()}</p>}
    </div>
  )
}

export default InputTextArea
